import AlternatingImages from '../helpers/alternatingimages';

import smt_2025 from '../images/2025-smt.jpg';
import Sections from '../helpers/sections';
import PageTemplate from '../helpers/pagetemp';

function MySMT() {

    var about_section = [
        <div className="spacious-text"> 
            The Stanford Math Tournament (SMT) is a high school math competition held annually in April. The tournament is run by students from Stanford University. The competition consists of several rounds, with many events the day before.
        </div>
    ]
 
    var past_result_sections = AlternatingImages({
        sections: [
            {
                title: "",
                description: ( 
                    <>
                        <h5>2025</h5>
                        <p>
                            We sent a team to the SMT competition for the first time. Our team placed <span className="emphasized-text">6<sup>th</sup></span> overall, with highlights including students placing <strong>4<sup>th</sup></strong> in Calculus (Anay Aggarwal) and <strong>5<sup>th</sup></strong> in Discrete (Shreyan Paliwal). <br /> <br />

                            <span className='team-text'>Team: Anay Aggarwal, Anshul Mantri, John Kong, Keshav Karumbunathan, Shreyan Paliwal, Vihaan Paliwal</span>
                        </p>
                    </>
                ),
                image: smt_2025
            }
        ],
        key: "past-results"
    });

    var description_section = [
        <div className="spacious-text">
            The competition has 6-member teams, with four rounds: a team round, a guts round, and two topic-based individual rounds (each competitor selects two from algebra, discrete, geometry, and calculus):
            <ul>
                <li><strong>Team Round:</strong> 15 computational problems in 60 minutes</li>
                <li><strong>Guts Round:</strong> 32 problems in 80 minutes, given in groups of 4, with a live leaderboard.</li>
                <li><strong>Individual Rounds:</strong> 10 problems in 50 minutes based on the category.</li>
            </ul>
        </div>
    ]

    var sections = [
        {
            "title": "About",
            "items": about_section, 
            enhance: true 
        },
        {
            "title": "Description", 
            "items": description_section, 
            enhance: true 
        },
        {
            "title": "Past Results",
            "items": past_result_sections, 
            enhance: true 
        }
    ];

    return <PageTemplate id="smt-page">
        <h1 className="my-5">SMT</h1>
        <Sections sections={sections} title_block={({ children }) => <h4>{children}</h4>} />
    </PageTemplate>
}

export default MySMT;
